import _ from "lodash";
import Document from "./Document";
import { useBookStore } from "stores/bookStore";
import { useAppStore } from "stores/appStore";
import { DOCUMENT_CATEGORY_HOC_LIEU_DIEN_TU } from "consts/book";

export default function SectionHocLieuDienTu() {
  const documents = useBookStore((state) => state.documents);
  const subjectId = useAppStore((state) => state.subjectId);
  const gradeId = useAppStore((state) => state.gradeId);
  const documentsOfCurrentGrade = _.get(documents, [gradeId], []);

  const hldtDocuments = documentsOfCurrentGrade.filter(
    (item) =>
      item.category === DOCUMENT_CATEGORY_HOC_LIEU_DIEN_TU &&
      item.subject_id === subjectId
  );

  return (
    !_.isEmpty(hldtDocuments) && (
      <div className="col-md-12 result">
        <Document
          data={hldtDocuments.slice(0, 4)}
          categoryBook="Học liệu điện tử"
          col="col-6 col-lg-3"
          background="#fff"
        />
      </div>
    )
  );
}
